//to be cont.
import { Col, Row } from "@/app/components/lib/my-bootstrap";
import SvgMinus from "./quantity-selector-icons/SvgMinus";
import SvgPlus from "./quantity-selector-icons/SvgPlus";
import SvgRecycleBin from "./quantity-selector-icons/SvgRecycleBin";
import Badge from "@/app/components/lib/badge";
import Tooltip from "@/app/components/lib/tooltip";
import SvgQuestionMark from "@/app/components/lib/SvgQuestionMark";
import AppToast from "@/app/components/lib/toast/AppToast";
import { useState } from "react";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useTranslation } from "@/hooks/localization/useTranslations";
import ExpandingQuantityInput from "@/app/components/common-builder/product/product-box/product-box-helpers/btn-expanding-add-to-card/btn-esxpanding-types/ExpandingQuantityInput";

interface Props {
  quantity: number;
  setQuantity: (count: number) => void;
  plusDisabled: boolean;
  /** Most that can be ordered; a typed quantity above it is never sent. */
  maxQuantity?: number;
  addedToCart: boolean;
  minQuantity: number;
  disableChangeQuantity?: boolean;
}

const BtnQuantitySelector: React.FC<Props> = ({
  quantity,
  setQuantity,
  plusDisabled,
  maxQuantity,
  addedToCart,
  minQuantity,
  disableChangeQuantity,
}) => {
  const t = useTranslation();
  const [openToast, setOpenToast] = useState(false);
  const isMobile = useIsMobile();
  return (
    <div>
      <Row className="m-0 btn-product-quantity-selector align-items-center flex-nowrap">
        <Col className="col-auto">
          <SvgRecycleBin
            onClick={(e) => {
              e.stopPropagation();
              setQuantity(0);
            }}
          />
        </Col>
        {!disableChangeQuantity && (
          <>
            {(quantity > minQuantity || !addedToCart) && (
              <Col className="col-auto">
                <SvgMinus
                  onClick={(e) => {
                    e.stopPropagation();
                    setQuantity(quantity - 1);
                  }}
                  disabled={quantity <= 1}
                />
              </Col>
            )}
            <Col className="p-0 d-flex justify-content-center">
              <div
                style={{ display: "flex", flexDirection: "column" }}
                onClick={() => {
                  isMobile && setOpenToast(true);
                }}
              >
                {minQuantity > 1 && minQuantity === quantity ? (
                  <Tooltip
                    text={`${t.min_quantity_in_cart} ${minQuantity}`}
                    skip={isMobile}
                    paddingTop={20}
                  >
                    <Badge
                      badgeComponent={<SvgQuestionMark />}
                      position="top-right"
                    >
                      <ExpandingQuantityInput
                        quantity={quantity}
                        setQuantity={setQuantity}
                        max={maxQuantity}
                      />
                    </Badge>
                  </Tooltip>
                ) : (
                  <ExpandingQuantityInput
                    quantity={quantity}
                    setQuantity={setQuantity}
                    max={maxQuantity}
                  />
                )}
              </div>
            </Col>
            <Col className="col-auto">
              <SvgPlus
                onClick={(e) => {
                  e.stopPropagation();
                  setQuantity(quantity + 1);
                }}
                disabled={plusDisabled}
              />
            </Col>
          </>
        )}
      </Row>
      <AppToast
        message={`${t.min_quantity_in_cart} ${minQuantity}`}
        setShow={setOpenToast}
        show={openToast}
        paddingBottom={130}
        width="300px"
        cancelIcon={false}
        delay={3000}
      />
    </div>
  );
};

export default BtnQuantitySelector;
